import React from 'react';
import Section from './Section';
import styled from 'styled-components';

function Home() {
    return (
        <Container>
            <Section 
                title='Model S'
                description = 'Order Online For Touchless Delivery'
                backgroundImg = 'model-s.jpg'
                leftBtnText ='Costom order'
                rightBtnText = 'Existing Inventory'
            />
            <Section 
                title='Model Y'
                description = 'Order Online For Touchless Delivery'
                backgroundImg = 'model-y.jpg'
                leftBtnText ='Costom order'
                rightBtnText = 'Existing Inventory'
            />
            <Section 
                title='Model 3'
                description = 'Order Online For Touchless Delivery'
                backgroundImg = 'model-3.jpg'
                leftBtnText ='Costom order'
                rightBtnText = 'Existing Inventory'
            />
            <Section 
                title='Model X'
                description = 'Order Online For Touchless Delivery'
                backgroundImg = 'model-x.jpg'
                leftBtnText ='Costom order'
                rightBtnText = 'Existing Inventory'
            />
            <Section 
                title='lowest Cost Solar Panel in America'
                description = 'Money-back guarantee'
                backgroundImg = 'solar-panel.jpg'
                leftBtnText ='Costom order'
                rightBtnText = 'Existing Inventory'
            />
            <Section 
                title='Solar for New Homes'
                description = 'Money-back guarantee'
                backgroundImg = 'solar-roof.jpg'
                leftBtnText ='Costom order'
                rightBtnText = 'Existing Inventory'
            />
            <Section 
                title='Accessories'
                description = ''
                backgroundImg = 'accessories.jpg'
                leftBtnText ='Shop Now'
            />
        </Container>
    )
}

export default Home


const Container = styled.div`
    height: 100vh;
`